module.exports = __webpack_public_path__ + "static/media/grayscale.89614cbb.jpg";